import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getRecipients, getSenders } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getDeliveryIdentifier as getSenderDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/senderGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import { useCallback, useState } from 'react';
import useWAThreadDetails from '../hooks/useWAThreadDetails';
import TemplateSendModal from './TemplateSendModal';
import { SendingAlert } from './SendingAlert';
import { getSingleDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/recipientGetters';
import { getDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/deliveryIdentifierGetters';
import { useWhatsAppSubscription } from '../hooks/useWhatsAppSubscription';
import { WABannerShepherd } from './WABannerShepherd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SendActionBanner({
  reply,
  onClose,
  onSend,
  inboxId
}) {
  const commonMessage = getCommonMessage(reply);
  const recipients = getRecipients(commonMessage);
  const recipient = recipients ? recipients.first() : null;
  const recipientDeliveryIdentifier = recipient && getSingleDeliveryIdentifier(recipient);
  const recipientPhoneNumber = recipientDeliveryIdentifier && getDeliveryIdentifierValue(recipientDeliveryIdentifier);
  const senders = getSenders(commonMessage);
  const sender = senders ? senders.first() : null;
  const senderDeliveryIdentifier = sender && getSenderDeliveryIdentifier(sender);
  const senderPhoneNumber = senderDeliveryIdentifier && getDeliveryIdentifierValue(senderDeliveryIdentifier);
  const {
    isSubscribedForTemplates,
    loading: whatsAppSubscriptionLoading
  } = useWhatsAppSubscription({
    endUserPhoneNumber: recipientPhoneNumber || '',
    hubSpotCustomerPhoneNumber: senderPhoneNumber || '',
    deferred: !recipientPhoneNumber || !senderPhoneNumber
  });
  const [showTemplateIframe, setShowTemplateIframe] = useState(false);
  const {
    threadDetails,
    loading: threadDetailsLoading
  } = useWAThreadDetails({
    recipient: recipient && getSingleDeliveryIdentifier(recipient),
    sender: senderDeliveryIdentifier
  });
  const handleOpen = () => setShowTemplateIframe(true);
  const handleClose = useCallback(() => {
    setShowTemplateIframe(false);
    if (onClose) onClose();
  }, [onClose, setShowTemplateIframe]);

  // TODO: we may want to implement some kind of UX that lets users know that we failed to fetch the status
  //       since the BE would actually block sending, then maybe we should still allow users to attempt to send?
  const isDataLoading = threadDetailsLoading || whatsAppSubscriptionLoading;
  if (isDataLoading && sender && recipient) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        height: '300px'
      },
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "medium"
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      height: '300px'
    },
    children: [/*#__PURE__*/_jsx(WABannerShepherd, {
      children: /*#__PURE__*/_jsx(SendingAlert, {
        inboxId: inboxId,
        openIframe: handleOpen,
        isSubscribedForTemplates: isSubscribedForTemplates,
        recipient: recipient,
        sender: sender,
        threadDetails: threadDetails
      })
    }), showTemplateIframe && recipient && sender && threadDetails && /*#__PURE__*/_jsx(TemplateSendModal, {
      messageLimitData: threadDetails.sessionQuotaMessageLimitStatus,
      recipient: recipient,
      message: commonMessage,
      handleClose: handleClose,
      onSend: onSend
    })]
  });
}
SendActionBanner.displayName = 'SendActionBanner';